import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1264ba7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tx-loading" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"tx-animate\" data-v-1264ba7c><div class=\"chain-countdown-animation\" data-v-1264ba7c><div class=\"animation-ball\" data-v-1264ba7c><div class=\"animation-ball-num font-bold\" data-v-1264ba7c><div class=\"left-num-animation\" data-v-1264ba7c><span data-v-1264ba7c>11011000101010110001010101</span></div><div class=\"center-num-animation\" data-v-1264ba7c><div class=\"center-num\" data-v-1264ba7c><span data-v-1264ba7c>11011000101010110001010101</span></div></div><div class=\"right-num-animation\" data-v-1264ba7c><span data-v-1264ba7c>11011000101010110001010101</span></div></div></div></div></div>", 1)
const _hoisted_3 = { class: "timing" }
const _hoisted_4 = { class: "wait-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-opacity" }, " Block confirmation in progress ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_greeting_card, {
      class: "tx-loading-greeting-card",
      img: require('@/assets/images/missionwagmiIcon/web_random.jpg')
    }, null, 8, ["img"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$tools.numFillZero(_ctx.timing.minu)) + ":" + _toDisplayString(_ctx.$tools.numFillZero(_ctx.timing.second)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _hoisted_5
    ])
  ]))
}